export const chainIDToName = {
  3: "ropsten",
  1: "mainnet",
  5: "goerli",
};
